export enum DatePlaceholders {
  withTime = 'withTime',
  open = 'open',
  na = 'N/A',
}
